import { Dialog } from '@material-ui/core';
import { ModalInfoIcon } from 'assets/icons';
import { useTranslation } from 'react-i18next';
import DialogCard from 'shared/components/dialog/dialogCard';
import Button from 'shared/components/form/button';
import './styles.scss';

interface BetBuilderDialogProps {
	openDialog: boolean;
	setDialogOpen: (isOpen: boolean) => void;
	onAddBetToCoupon: () => void;
	clickOnCross: any;
}

const BetBuilderDialog = ({ openDialog, setDialogOpen, onAddBetToCoupon, clickOnCross }: BetBuilderDialogProps) => {
	const { t } = useTranslation();

	const handleLoginRedirection = async () => {
		onAddBetToCoupon();
		setDialogOpen(false);
	};

	return (
		<Dialog
			maxWidth="xs"
			fullWidth
			onClose={() => setDialogOpen(false)}
			className="custom-dialog bg--transparent custom--box-shadow text--center"
			aria-labelledby="customized-dialog"
			open={openDialog}
		>
			<DialogCard
				className="betBuilderDialog__dialog"
				icon={() => <ModalInfoIcon className="betBuilderDialog__icon" />}
				titleClass="betBuilderDialog__title"
				subTitle={t('betBuilderDialogSubtitle')}
				subTitleClass="betBuilderDialog__subtitle"
				cardBottomCustom={
					<div className="betBuilderDialog__buttonSection">
						<Button btnType="secondary" onClick={handleLoginRedirection}>
							{t('betBuilderDialogButtonText')}
						</Button>
						<Button btnType="card-button-grey" className="betBuilderDialog__cancelButton" onClick={() => setDialogOpen(false)}>
							{t('cancel')}
						</Button>
					</div>
				}
			/>
		</Dialog>
	);
};

export default BetBuilderDialog;
